import { useRouter } from 'next/router';

import { useOpenWindow } from '@/hooks/useLocale';

/**
 * 완료 토스트의 `보러 가기` 가 목적지로 가는 방법.
 *
 * 작업 중인 화면(퀴즈 수정 등)을 벗어나면 안 되는 곳은 `inNewTab` 으로 새 탭에 연다.
 */
export const useNavigateToSaveResult = (inNewTab = false) => {
  const router = useRouter();
  const openWindow = useOpenWindow();

  return (destination: string) => {
    if (inNewTab) {
      openWindow(destination);
      return;
    }
    void router.push(destination);
  };
};
